import axios from "axios";
import { API_URL } from "@/config";

const store = {
  namespaced: true,

  actions: {
    async getMany(_, { filters, pageNumber, perPage }) {
      let q = {
        ...filters,
        page: pageNumber,
      };

      if (perPage) {
        q.perPage = perPage;
      }

      const res = await axios.get(`${API_URL}/tickets`, { params: q });

      if (!res.data || typeof res.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getOne(_, ticketId) {
      const res = await axios.get(`${API_URL}/tickets/${ticketId}`);

      if (!res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async close(_, ticketId) {
      const res = await axios.post(`${API_URL}/tickets/${ticketId}/close`);

      if (res.status !== 200 || !res.data || res.data.status !== true) {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },
  },
};

export default store;
